import gql from 'graphql-tag';

import integrationEmailFragment from '../fragments/integrationEmailFragment';

export default gql`
  query integrationEmail(
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    integrationEmail(
      integrationID: $integrationID
      remoteID: $remoteID
    ) {
      ...integrationEmailFragment
    }
  }
  ${integrationEmailFragment}
`;
